export default __webpack_public_path__ + "static/media/Pezzella.41b2f218.jpg";